export const toggleDarkMode = () => {
  // Get the toggle button element
  const toggleButton = document.querySelector(".js-dark-mode-toggle");

  if (toggleButton) {
    // Add event listener to the toggle button
    toggleButton.addEventListener("click", () => {
      //Toggle between data-theme="light" and data-theme="dark" on body
      document.body.dataset.theme =
        document.body.dataset.theme === "dark" ? "light" : "dark";
    });
    
    // toggleButton.addEventListener("mouseover", () => {
    //   document.body.dataset.theme =
    //     document.body.dataset.theme === "dark" ? "light" : "dark";
    // });
   
  }

  // Function to apply the correct theme
  function applyTheme(theme) {
    if (theme === "dark") {
      document.body.dataset.theme = "dark";
    } else {
      document.body.dataset.theme = "light";
    }
  }

  // Initial check
  const prefersDarkScheme = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;
  applyTheme(prefersDarkScheme ? "dark" : "light");

  // Listen for changes in the prefers-color-scheme media query
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", function (e) {
      applyTheme(e.matches ? "dark" : "light");
    });


};